<template>
<span></span>
</template>

<script>
export default {
    name: 'empty-chart'
}
</script>



// WEBPACK FOOTER //
// EmptyChart.vue?648e8676